export const getIndexConfig = async (index: string, key: number) => {
  const axiosInstance = require('utils/utils-axios-instance').default;
  const data = await axiosInstance.get(`index/${index}/api/configs/${key}`);
  return data.data;
};
